import { useState, useEffect, useRef } from 'react';

const useCountUp = (end, duration = 2000, startOnView = true) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const elementRef = useRef(null);

  // Animation function
  const startAnimation = () => {
    if (hasStarted) return;
    
    console.log('Starting animation for:', end);
    setHasStarted(true);
    
    const startTime = Date.now();
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Smooth easing function
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * end);
      
      setCount(currentCount);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
        console.log('Animation completed for:', end);
      }
    };

    requestAnimationFrame(animate);
  };

  useEffect(() => {
    if (!startOnView) {
      // Start immediately if not waiting for view
      startAnimation();
      return;
    }

    // Create intersection observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasStarted) {
            console.log('Element came into view:', end);
            startAnimation();
          }
        });
      },
      { 
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Observe the element after a short delay to ensure it's mounted
    const timer = setTimeout(() => {
      if (elementRef.current) {
        console.log('Starting to observe element for:', end);
        observer.observe(elementRef.current);
      } else {
        console.log('Element ref not found for:', end);
      }
    }, 200);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [end, duration, startOnView, hasStarted]);

  return { count, elementRef };
};

export default useCountUp;